import React, { useEffect, useState } from "react";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  TitleWrapper,
  AboutLegislationContainer,
  ContentWrapper,
  SubtitleWrapper,
  BackToGuidesWrapper,
  NoDataContainer,
  SvgContainer,
} from "./AboutRegulationsStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//ASETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import { ReactComponent as NoData } from "assets/svg/NoData.svg";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";
import aboutService from "services/aboutService";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// HOOKS
import usePagination from "hooks/usePagination";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import Pagination from "components/Atoms/Paginations/Pagination";
import ParagraphAtom from "components/Atoms/ParagraphAtom/ParagraphAtom";

// CONFIGURATION

const AboutRegulations = () => {
  // PROPERTIES
  const ELEMENTS_PER_PAGE = 15;

  // API REQUESTS

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [legislation, setLegislation] = useState<any>(null);

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getLegislationOrganisation('secundara')
      .then((response) => {
        // console.log("getLegislation response", response);
        setLegislation(response);
      })
      .catch((err) => {
        console.log("getLegislation error", err);
      });
  }, []);

  const { currentPage, totalPages, currentData, handlePageChange } =
    usePagination(legislation?.data || [], ELEMENTS_PER_PAGE);

  const legislationData = (
    <ContentWrapper>
      {currentData?.length > 0 ? (
        currentData.map((file) => (
          <ParagraphAtom
            key={file.id}
            text={file.attributes.title}
            href={file.attributes.doc_link}
          />
        ))
      ) : (
        <NoDataContainer>
          <SvgContainer>
            <NoData />
          </SvgContainer>
          <CustomText
            text={t("app.noData")}
            type={TextType.H4}
            color={COLORS.Cultured}
          />
        </NoDataContainer>
      )}
    </ContentWrapper>
  );

  // EVENT HANDLERS

  return (
    <AboutLegislationContainer>
      <BackToGuidesWrapper
        biggerCursor={biggerCursor}
        onClick={() => navigate(appRoutes.about)}
      >
        <BackToGuidesImage src={LeftArrow} alt="backIcon" />
        <BackToGuidesButton>
          <CustomText
            text={t("view.about.aboutRegulations.button")}
            type={TextType.H5boldspaced}
            color={COLORS.RaisinBlack}
          />
        </BackToGuidesButton>
      </BackToGuidesWrapper>
      <TitleWrapper>
        <CustomText
          type={TextType.H2}
          text={t("view.about.aboutRegulations.title")}
        />
      </TitleWrapper>
      {legislationData}
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </AboutLegislationContainer>
  );
};

export default AboutRegulations;
